/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Copy_FailedInputs */

const th_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกลิงก์ไม่ได้ โปรดเลือกลิงก์ด้านบนแล้วคัดลอกด้วยตนเอง`)
};

const en_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy the link. Select it above and copy it manually.`)
};

const ja_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピーできませんでした。上のリンクを選択してコピーしてください。`)
};

const zh_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法复制链接。请在上面选中后自行复制。`)
};

const es_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido copiar el enlace. Selecciónalo arriba y cópialo manualmente.`)
};

const pt_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível copiar o link. Selecione-o acima e copie manualmente.`)
};

const id_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan tidak bisa disalin. Sorot di atas lalu salin sendiri.`)
};

const fr_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de copier le lien. Sélectionnez-le ci-dessus et copiez-le manuellement.`)
};

const tl_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nakopya ang link. I-highlight ito sa itaas at kopyahin mismo.`)
};

const vi_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không chép được liên kết. Bôi đen ở trên rồi tự chép.`)
};

const ko_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크를 복사하지 못했습니다. 위에서 직접 선택해 복사하세요.`)
};

const de_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Link konnte nicht kopiert werden. Markiere ihn oben und kopiere ihn selbst.`)
};

const ru_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылку не удалось скопировать. Выделите её выше и скопируйте сами.`)
};

const tr_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı kopyalanamadı. Yukarıdan seçip kendiniz kopyalayın.`)
};

const it_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile copiare il link. Selezionalo qui sopra e copialo tu.`)
};

const pl_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się skopiować linku. Zaznacz go powyżej i skopiuj sam.`)
};

const uk_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося скопіювати посилання. Виділіть його вище та скопіюйте самі.`)
};

const hi_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक कॉपी नहीं हो सका। ऊपर उसे चुनकर स्वयं कॉपी करें।`)
};

const ar_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر نسخ الرابط. حدّده أعلاه وانسخه بنفسك.`)
};

const ms_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautan tidak dapat disalin. Tandakannya di atas dan salin sendiri.`)
};

const bn_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিঙ্ক কপি করা যায়নি। উপরে নির্বাচন করে নিজে কপি করুন।`)
};

const zh_tw2_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法複製連結。請在上方選取後自行複製。`)
};

const zh_hk2_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法複製連結。請在上方選取後自行複製。`)
};

const ur_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنک نقل نہیں ہو سکا۔ اوپر منتخب کر کے خود نقل کریں۔`)
};

const fa_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیوند رونوشت نشد. آن را در بالا برگزینید و خودتان رونوشت بگیرید.`)
};

const sw_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiungo hakikunakiliwa. Kichague hapo juu kisha ukinakili mwenyewe.`)
};

const nl_meeting_test_copy_failed = /** @type {(inputs: Meeting_Test_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De link kon niet worden gekopieerd. Selecteer hem hierboven en kopieer hem zelf.`)
};

/**
* | output |
* | --- |
* | "Could not copy the link. Select it above and copy it manually." |
*
* @param {Meeting_Test_Copy_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_copy_failed = /** @type {((inputs?: Meeting_Test_Copy_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Copy_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_copy_failed(inputs)
	if (locale === "ja") return ja_meeting_test_copy_failed(inputs)
	if (locale === "zh") return zh_meeting_test_copy_failed(inputs)
	if (locale === "es") return es_meeting_test_copy_failed(inputs)
	if (locale === "pt") return pt_meeting_test_copy_failed(inputs)
	if (locale === "id") return id_meeting_test_copy_failed(inputs)
	if (locale === "fr") return fr_meeting_test_copy_failed(inputs)
	if (locale === "tl") return tl_meeting_test_copy_failed(inputs)
	if (locale === "vi") return vi_meeting_test_copy_failed(inputs)
	if (locale === "ko") return ko_meeting_test_copy_failed(inputs)
	if (locale === "de") return de_meeting_test_copy_failed(inputs)
	if (locale === "ru") return ru_meeting_test_copy_failed(inputs)
	if (locale === "tr") return tr_meeting_test_copy_failed(inputs)
	if (locale === "it") return it_meeting_test_copy_failed(inputs)
	if (locale === "pl") return pl_meeting_test_copy_failed(inputs)
	if (locale === "uk") return uk_meeting_test_copy_failed(inputs)
	if (locale === "hi") return hi_meeting_test_copy_failed(inputs)
	if (locale === "ar") return ar_meeting_test_copy_failed(inputs)
	if (locale === "ms") return ms_meeting_test_copy_failed(inputs)
	if (locale === "bn") return bn_meeting_test_copy_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_copy_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_copy_failed(inputs)
	if (locale === "ur") return ur_meeting_test_copy_failed(inputs)
	if (locale === "fa") return fa_meeting_test_copy_failed(inputs)
	if (locale === "sw") return sw_meeting_test_copy_failed(inputs)
	if (locale === "nl") return nl_meeting_test_copy_failed(inputs)
	return en_meeting_test_copy_failed(inputs)
});